export class NoticesApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = 'NoticesApiError';
  }
}

export type FormattedError = {
  message: string;
  httpStatus?: number;
};

export function formatApiError(error: unknown): FormattedError {
  if (error instanceof NoticesApiError) {
    const prefix = error.statusCode ? `HTTP ${error.statusCode}: ` : '';
    return {
      message: `${prefix}${error.message}`,
      httpStatus: error.statusCode,
    };
  }

  if (error instanceof Error) {
    return { message: error.message };
  }

  return { message: String(error) };
}
